import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { getContentfulEntries } from '../actions';

/**
 * Generic hook to fetch entries directly from Contentful's Content
 * Delivery API.
 * `contentType` is used for fetching the data
 * `key` is used for storing it in Redux.
 * `query` accepts any Contentful search parameter, e.g.
 * `{ 'fields.platform': 'web', locale: 'en-US' }`.
 */
const useContentfulEntries = ({ contentType, key, query = {} }) => {
  const dispatch = useDispatch();

  const contentfulData = useSelector(({
    contentful,
  }) => contentful[key], shallowEqual);

  useEffect(() => {
    dispatch(getContentfulEntries({ contentType, key, query }));
  }, [key]);

  return {
    data: contentfulData?.data ?? null,
    error: contentfulData?.error ?? null,
    loading: contentfulData?.loading ?? true,
  };
};

export { useContentfulEntries };
